import React from "react";

/**
 * Small reusable "Export to Excel" button used across the Trial Balance report views.
 * Pass an onClick handler that builds and downloads the .xlsx file.
 */
function ExportExcelButton({ onClick, label = "Export to Excel" }) {
  return (
    <div className="flex justify-end print:hidden">
      <button
        type="button"
        onClick={onClick}
        className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white text-xs font-semibold uppercase tracking-wide rounded-md shadow-sm transition-colors"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-4 h-4"
        >
          <path d="M4 4h10l6 6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
          <path d="M14 4v6h6" />
          <path d="M9 15l2.5 3L14 14" />
        </svg>
        {label}
      </button>
    </div>
  );
}

export default ExportExcelButton;
